import { semantic } from './preset/semantic';
import { components } from './preset/components';
import { primitive } from './preset/primitive';
import { definePreset } from '@primeuix/themes';
import Material from '@primeuix/themes/material';

export const arsktrpTheme = definePreset(Material, {
  primitive,
  semantic,
  components,
});
